import { AccountCircleOutlined, SettingsOutlined } from "@mui/icons-material";
import MenuIcon from "@mui/icons-material/Menu";
import { Grid, IconButton, Menu, MenuItem, PaletteMode, Typography, useTheme } from "@mui/material";
import { MouseEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useKaziNavigate } from "../../../Hooks/useKaziNavigate";
import { VerticalNavbarItem } from "./VerticalNavbar";
import { SettingsHamburger } from "./SettingsHamburger";

interface VerticalHamburgerProps {
    mode: PaletteMode;
    pages: VerticalNavbarItem[];
    getSettings: () => VerticalNavbarItem[];
}

export const VerticalHamburger = ({ mode, pages, getSettings}: VerticalHamburgerProps) => {
    /* ******************** Hooks ******************** */
    const navigate = useNavigate();
    const theme = useTheme();
    const { navigateToProfile, navigateToSettings } = useKaziNavigate();
    /* ******************** Variables ******************** */
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [menuOpen, setMenuOpen] = useState(false);
    /* ******************** Functions ******************** */
    const handeMenuOpen = (event: MouseEvent<HTMLElement>) =>{
        setAnchorEl(event.currentTarget);
        setMenuOpen(!menuOpen);
    } 
    const handeMenuClose = () =>{
        setAnchorEl(null);
        setMenuOpen(false);
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <Grid 
            item  
            display={"flex"} 
            flexDirection={"row"} 
            paddingX={4}  
            xs="auto" 
            bgcolor={'background.secondary'} 
            borderBottom={mode === 'dark' ? '1px solid white' : "none"}
        >
                
            <Grid item >
                <img src="/kazilogo.png" width={178} height={58} alt="Kazi Konekt logo" />
            </Grid>
            <Grid  item display={"flex"} justifyContent={"flex-end"} alignItems={"center"} flex={1}>
                <IconButton color="primary" onClick={handeMenuOpen}>
                    <MenuIcon />
                </IconButton>
                <Menu
                    anchorEl={anchorEl}
                    open={menuOpen}
                    onClose={handeMenuClose}
                >
                    {pages.map((page, idx) => (
                        <MenuItem 
                            key={idx} 
                            onClick={() => {navigate(`/${page.link}`)}}
                            disabled={page.disabled}
                        >
                            <Typography textAlign="center">{page.label}</Typography>
                        </MenuItem>
                    ))}
                    {/* <ThemeToggle /> */}
                </Menu>
                <IconButton onClick={navigateToProfile}>
                    <AccountCircleOutlined color="primary" fontSize="small"/>
                </IconButton>                
                <SettingsHamburger mode={theme.palette.mode} pages={getSettings()}/>
            </Grid>
        </ Grid>
    )
}